module.exports = require("!!vue-loader!./node_modules/v-markdown-loader/_cache/404-1.vue");


//////////////////
// WEBPACK FOOTER
// ./404.md
// module id = 474
// module chunks = 474